/** Up-to-2 initials from a name. */
export function initials(name: string): string {
  return (
    name
      .split(/\s+/)
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?'
  );
}

/** Whole-dollar display ("$1,560"). */
export function money0(value: string | number): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return '$0';
  return '$' + n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2025-11-21" → "Nov 21, 2025". Date-only, no timezone shift. */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}`;
}

/**
 * Google Maps search URL for an address. Works cross-platform — opens the Maps
 * app on Android and Maps (or browser) on iOS. Returns null if no usable parts.
 */
export function mapsUrl(...parts: (string | null | undefined)[]): string | null {
  const query = parts
    .map((p) => (p ?? '').trim())
    .filter(Boolean)
    .join(', ');
  if (!query) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Two-decimal display ("$12.34"). */
export function money2(value: string | number): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return '$0.00';
  return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
